// extracted by mini-css-extract-plugin
export default {"form":"CheckoutForm_form__xKbcy","submitButton":"CheckoutForm_submitButton__QKyw+","errorMessage":"CheckoutForm_errorMessage__GdABW"};